import {object, string} from "yup";

const {replaceLocation, Link} = require("../../../../router");
const {
  LINK_BLOCKED,
  LINK_RESET_SECURITY_VERIFICATION
} = require("../../../../constants/links");
const {apiAuthTfaVerify, getAccountsList} = require("../../../../api/_auth");
const {account$, getUserMainPage, cachedAccount$} = require("../../../../emitters/account");
const {LayoutAuthWithForm} = require("../../../layouts");
const {MerchantInputCode} = require("../../../helpers/InputsHelpers");
const React = require("react");

export default () => {
  const email = localStorage.getItem('email') || '';
  const schema = object({code: string().length(6, 'Code must be exactly 6 characters').required()});
  const cachedAccount = cachedAccount$.getValue();

  if (!cachedAccount) {
    replaceLocation({
      path: '/',
    });
  }

  const onSubmit = (params) => (
    apiAuthTfaVerify(params)
        .then((response) => {
          if (response && response.blocked) {
            replaceLocation({
              path: LINK_BLOCKED + '/' + email + '/',
            });
            return;
          }

          getAccountsList(cachedAccount).then((accountData) => {
            account$.emit(accountData);
            replaceLocation({
              path: getUserMainPage(),
            });
          })
        })
  );

  return (
    <LayoutAuthWithForm
      title="Security verification"
      formProps={{
        schema,
        onSubmit
      }}
      content={(formCtx) => (
        <MerchantInputCode
          label="Enter the 6 digit authentication code"
          name="code"
          formCtx={formCtx}
          codeLength={6}
        />
      )}
      submitBtnText="Submit"
      additional={(
        <div className="f12 fw3 lh lts0em">
          <Link
            href={LINK_RESET_SECURITY_VERIFICATION}
            className="c5B47FF olN tdU dn f12 fw3 o70:h"
          >Lost access to verification?</Link>
        </div>
      )}
    />
  );
}
